import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import DeviceStorage from "../../../components/DeviceStorage/DeviceStorage";
import Utils from '../../../utils/Utils';
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';
import AAF from "../../../AAF/AAF";
import { EPG_VERSION_TTL} from '../../../AAF/Resilence/TTLConstants';

const TTLItem = EPG_VERSION_TTL;

class VerticalLookUp extends AbstractRequestTask {
  constructor(value = "", field = "", provider_id ="", from = 0, quantity = 20, id_rol = "") {
    super();

    this.value = value;
    this.field = field;
    this.from = from;
    this.quantity = quantity;
    this.provider_id= provider_id;
    this.id_rol= id_rol;
  }

  APAFilters(){
    return Utils.getApaMetadataKey('byr_filterlist_configuration', '{}', 'filterlist')
  }

  getHeaders() {
    return {};
  }

  getUrl() {
    const http = "https://";
    const url = Launcher.get("akamai_mfwk");
    return `${http}${url}/services/search/vertical`;
  }

  getParams() {
    const params = super.getParams();
    AAF.TTLUtil.verifyTTLItem(TTLItem, () => { AAF.TTLUtil.setEpgVersion(); }, 'VerticalTask[getParams]');
    const epg_version = DeviceStorage.getItem('epgVersion');

    return {
      ...params,
      value: this.value,
      field: this.field,
      from: this.from,
      quantity: this.quantity,
      epg_version,
      provider_id: this.provider_id ? this.provider_id : '2', // default AMCO --> https://dlatvarg.atlassian.net/wiki/spaces/GCV/pages/204078641/search+vertical+V6
      filterlist: this.APAFilters(),
      id_rol: this.id_rol
    };
  }

  success(data, b) {
    this.resolve(data);
  }

  getShowErrorModal(){
    return ENABLE_MODAL_RETRIES;
  }
}

export default VerticalLookUp;



// WEBPACK FOOTER //
// ./src/requests/tasks/search/VerticalTask.js